import React from 'react';
import SireList from 'components/Tvendo/Common/Sire/SireList';
import { ConstantPermissions } from 'contexts/useConstant';

export default function SalesSire() {
  return (
    <SireList
      entity="sale/sire"
      title="Ventas SIRE"
      permission={ConstantPermissions.SALE_SIRE_CONCILIATIONS_STORE}
      updatePermission={ConstantPermissions.SALE_SIRE_CONCILIATIONS_UPDATE}
      deletePermission={ConstantPermissions.SALE_SIRE_CONCILIATIONS_DESTROY}
      excelName="sire_comprobante_ventas"
    />
  );
}
